import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Plan Card',
    inputs: [
        {
            name: 'planCode',
            type: 'string',
        },
        {
            name: 'nameOverride',
            type: 'string',
        },
        {
            name: 'description',
            type: 'string',
        },
        {
            name: 'features',
            type: 'richText',
        },
        {
            name: 'primaryButton',
            type: 'boolean',
            defaultValue: false,
        },
        {
            name: 'buttonText',
            type: 'string',
            defaultValue: 'Select Plan',
        },
        {
            name: 'countryCode',
            type: 'string',
        },
    ],
    defaults: {
        bindings: {
            'component.options.countryCode': 'state.locale',
            'component.options.isAuthenticated': 'state.isAuthenticated',
        },
    },
};
